import React from 'react'
import 'antd/dist/antd.css';
import { Layout, Input, Button, Row, message, Typography, Table, Form, DatePicker, Tabs, Popconfirm, } from 'antd';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import TextEditing from '../../TextEditing/index'
import RecruitDetail from '../../../../pages/Backstage/Recruit/RecruitDetail'
const { TabPane } = Tabs;
const { Content } = Layout;
const { Title } = Typography;
import store from '../../../../redux/store'
import actionWays from '../../../../redux/actions'
import { getRecruitment, deleteRecruit } from '../../../../utils/api/index'
class TabsBase extends React.Component {
  constructor(props) {
    console.log(props)
    super(props);
    this.state = {
      data: props.params,
      constructionVisible: false,
      particularsContent: {},
      particularsVisible: false,
      index: Number(props.pageNo) + 1,
      pageTotal: Number(props.pageTotal),
      isChange: false

    };
    console.log(props.params)
    this.industryNews = null
  }
  // componentDidMount(){
  //   this.getPages()
  // }
  //赋值详情
  handleParticularsVisible = async (value) => {
    this.setState({
      particularsVisible: value
    })
  }
  //删除招聘信息
  delete = async (e) => {
    let res = await deleteRecruit(e)
    if (res.code === 0) {
      message.success('删除成功')
      this.getPages()
    }
  }
  //获取列表信息
  getPages = async () => {
    this.setState({
      loading: true
    })
    let opt = {}
    let res = await getRecruitment()
    if (res.code === 0) {
      this.setState({
        data: res.data,
      })
    } else {
      if (!!res) {
        message.error(res.message)
      } else {
        message.error('接口异常')
        this.setState({
          loading: false
        })
      }
    }
    //新建列表信息

  }
  //获取详情信息
  getParticulars = (value) => {
    console.log(value)
    this.setState({
      particularsContent: value
    }, () => {
      this.handleParticularsVisible(true)
    })
  }
  //列表页
  columns = [
    {
      title: '招聘职位',
      dataIndex: 'positionName',
    },
    {
      title: '发布时间',
      dataIndex: 'recordtime',
      valueType: 'date',
    },
    {
      title: '操作人员',
      dataIndex: 'operator',
      search: false,
    },
    {
      title: '操作时间',
      dataIndex: 'operatorTime',
      search: false,
    },
    {
      title: '招聘人数',
      dataIndex: 'numbers',
      search: false,
    },
    {
      title: '招聘部门',
      dataIndex: 'department',
      search: false,
    },
    {
      title: '薪资区间',
      dataIndex: 'wage',
      search: false,
    },
    {
      title: '操作',
      dataIndex: 'option',
      valueType: 'option',
      render: (_, record) => [
        <Popconfirm
          onConfirm={() => { this.delete({ id: record.pid }) }}
          title="确认删除？">
          <a style={{ color: 'rgb(75, 190, 205)' }} href="#">删除 </a>
        </Popconfirm>,
        <a style={{ color: 'rgb(75, 190, 205)' }} onClick={() => { this.getUpdateConstruction(record) }
        }> 编辑 </a>,
        <a style={{ color: 'rgb(75, 190, 205)' }} onClick={() => { this.getParticulars(record) }
        }> 详情 </a>
      ],
    },
  ];
  //编辑
  getUpdateConstruction = (value) => {
    this.setState({
      constructionVisible: value,
      isChange: value.pid
    }, () => {
      const info = store.getState()
      console.log(info)
      console.log(value)
      if (info.backFormData != '') {
        info.backFormData[0].value = value.positionName
        info.backFormData[1].value = value.wage
        info.backFormData[2].value = value.status
        info.backFormData[3].value = value.numbers
        info.backFormData[4].value = value.address
        info.backFormData[5].value = value.department
        info.backFormData[6].value = value.positionContext
        info.backFormData[7].value = value.positionRequirements
        let formData = {
          formList: info.backFormData
        }
        const actions = actionWays.saveFormData({ ...formData })
        store.dispatch(actions)
      } else {
        let formData = {
          formList: [{
            name: 'positionName',
            label: '招聘职位',
            type: 'Input',
            baseInfo: [''],
            render: '',
            value: value.positionName,
            rules: [{ required: true, message: '请填写完整' }]
          }, {
            name: 'wage',
            label: '薪资区间',
            type: 'Input',
            baseInfo: [''],
            render: '',
            value: value.wage,
            rules: [{ required: true, message: '请填写完整' }]
          }, {
            name: 'status',
            label: '岗位状态',
            type: 'Select',
            baseInfo: ['正常', '急招'],
            render: '',
            value: value.status,
            rules: [{ required: true, message: '请填写完整' }]
          }, {
            name: 'numbers',
            label: '招聘人数',
            type: 'InputNumber',
            baseInfo: [''],
            render: '',
            value: value.numbers,
            rules: [{ required: true, message: '请选择' }]
          }, {
            name: 'address',
            label: '工作地点',
            type: 'Input',
            baseInfo: [''],
            render: '',
            value: value.address,
            rules: [{ required: true, message: '请填写完整' }]
          }, {
            name: 'department',
            label: '部门',
            type: 'Input',
            baseInfo: [''],
            render: '',
            value: value.department,
            rules: [{ required: true, message: '请填写完整' }]
          },
          {
            name: 'positionContext',
            label: '岗位描述',
            type: 'Input',
            baseInfo: [''],
            render: '',
            value: value.positionContext,
            rules: [{ required: true, message: '请填写完整' }]
          },
          {
              name: 'positionRequirements',
              label: '任职要求',
              type: 'Input',
              baseInfo: [''],
              render: '',
              value: value.positionRequirements,
              rules: [{ required: true, message: '请填写完整' }]
          }
          ]
        }
        console.log(1)
        const actions = actionWays.saveFormData({ ...formData })
        store.dispatch(actions)
      }
    })
  }
  //更新数据
  handleConstructionVisible = async (value) => {
    this.setState({
      constructionVisible: value,
      isChange:false
    })
  };
  render() {
    const { constructionVisible, data, particularsVisible, particularsContent, pageTotal, isChange } = this.state
    return (
      <Layout style={{ width: '100%' }}>
        <div id='new' style={{ margin: '0 auto' }}>
          <div className="col-lg-1"></div>
          <div className="col-lg-10">
            <div className='new_Content'>
              <div className='button' style={{ float: "right", marginTop: '6px' }}>
                <Button onClick={() => this.handleConstructionVisible(true)} style={{ background: '#0093D8', color: '#fff' }}>
                  新建招聘
                </Button>
              </div>
              <Tabs defaultActiveKey={status} >
                {/* <TabPane tab="发布" key="0">
                </TabPane> */}
                {/* <TabPane tab="草稿" key="1">
                </TabPane> */}
              </Tabs>
              <Table className='testmsk' dataSource={data.pageContent} columns={this.columns} pagination={{ defaultCurrent: this.index, total: this.props.params.current, pageSize: 20 }}/>
              {/* {
                pageTotal > 1 ? <Paginations index={index} current={index} defaultCurrent={1} total={this.props.pageTotal} /> : ''
              } */}
            </div>
          </div>
          <div className="col-lg-1"></div>
        </div>
        <RecruitDetail particularsContent={particularsContent} userLoginInfo={this.props.userLoginInfo} particularsVisible={particularsVisible} handleParticularsVisible={this.handleParticularsVisible} />

        {constructionVisible ? <TextEditing isChange={isChange} getPages={this.getPages} userLoginInfo={this.props.userLoginInfo} constructionVisible={constructionVisible} handleConstructionVisible={this.handleConstructionVisible} /> : null}
      </Layout>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    userLoginInfo: state.userLoginInfo,
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
  }
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TabsBase))
